module.exports = __webpack_public_path__ + "static/media/Gallery_Slider_2-min.0984757f.jpg";